'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _elementHelper = require('../../../common/elements/elementHelper');

var _point = require('../../../common/maths/geometry/point');

var pointLib = _interopRequireWildcard(_point);

var _dndConstants = require('../../utils/dnd/dndConstants');

var _dragAndDropUtils = require('../../utils/dnd/dragAndDropUtils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Constants
// Utils
var isGrabbedElement = function isGrabbedElement(_ref) {
    var grabbedElement = _ref.grabbedElement,
        element = _ref.element;
    return grabbedElement.get('id') === element.get('id');
};

// Drag offsets
var getBoardInListOriginOffset = function getBoardInListOriginOffset(_ref2) {
    var element = _ref2.element,
        gridSize = _ref2.gridSize,
        measurementsMap = _ref2.measurementsMap;

    var selectedElementMeasurements = measurementsMap.get(element.get('id'));
    var originOffset = selectedElementMeasurements.get('originOffset').toJS();
    return pointLib.difference((0, _dragAndDropUtils.getBoardIconCentreOffset)({ gridSize: gridSize }), originOffset);
};

/**
 * This handles situations where the element needs to be repositioned because the dragged preview is not visually
 * the same as the element that was grabbed (for example, boards in a list are a different shape).
 */
var getElementOriginOffset = function getElementOriginOffset(_ref3) {
    var grabbedElement = _ref3.grabbedElement,
        element = _ref3.element,
        gridSize = _ref3.gridSize,
        measurementsMap = _ref3.measurementsMap;

    // A grabbed element has to be handled in the drag layer and the drop handler because the mouse offset information
    // is not available at this time (beginDrag)
    if (isGrabbedElement({ grabbedElement: grabbedElement, element: element })) return _dndConstants.NO_DRAG_OFFSET;

    if ((0, _elementHelper.isBoardLike)(element) && (0, _elementHelper.isInList)(element)) {
        return getBoardInListOriginOffset({ element: element, gridSize: gridSize, measurementsMap: measurementsMap });
    }

    return _dndConstants.NO_DRAG_OFFSET;
};

var getSelectedElementTranslation = function getSelectedElementTranslation(_ref4) {
    var grabbedElement = _ref4.grabbedElement,
        element = _ref4.element,
        measurementsMap = _ref4.measurementsMap;

    var selectedElementPosition = measurementsMap.get(element.get('id'));

    // If this element is the grabbed element, no translation is necessary
    if (isGrabbedElement({ grabbedElement: grabbedElement, element: element })) {
        return _dndConstants.NO_DRAG_OFFSET;
    }

    var grabbedElementPosition = measurementsMap.get(grabbedElement.get('id'));

    return {
        x: selectedElementPosition.get('left') - grabbedElementPosition.get('left'),
        y: selectedElementPosition.get('top') - grabbedElementPosition.get('top')
    };
};

var getElementOffset = function getElementOffset(_ref5) {
    var grabbedElement = _ref5.grabbedElement,
        element = _ref5.element,
        measurementsMap = _ref5.measurementsMap,
        gridSize = _ref5.gridSize;
    return pointLib.translate(getElementOriginOffset({ grabbedElement: grabbedElement, element: element, gridSize: gridSize, measurementsMap: measurementsMap }), getSelectedElementTranslation({ grabbedElement: grabbedElement, element: element, measurementsMap: measurementsMap }));
};

var addOffsetToMapReducer = function addOffsetToMapReducer(_ref6) {
    var grabbedElement = _ref6.grabbedElement,
        measurementsMap = _ref6.measurementsMap,
        gridSize = _ref6.gridSize;
    return function (offsetMap, element) {
        offsetMap[element.get('id')] = getElementOffset({ grabbedElement: grabbedElement, element: element, measurementsMap: measurementsMap, gridSize: gridSize });
        return offsetMap;
    };
};

exports.default = function (_ref7) {
    var grabbedElement = _ref7.grabbedElement,
        draggedElements = _ref7.draggedElements,
        measurementsMap = _ref7.measurementsMap,
        gridSize = _ref7.gridSize;
    return draggedElements.reduce(addOffsetToMapReducer({ grabbedElement: grabbedElement, measurementsMap: measurementsMap, gridSize: gridSize }), {});
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/dnd/buildElementOffsetsMap.js
// module id = 1972
// module chunks = 0